import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectUser } from 'entities/user/selectors';
import User from 'entities/user/model';
import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';

import NonprofitNominationsTable from './NonprofitNominationsTable';

const NonprofitNominationsPage = (): React.ReactElement => {
  const [viewAllCompanies, setViewAllCompanies] = useState(false);

  const user: User = useSelector(selectUser);
  const history = useHistory();

  const hasGlobalHandleNonprofitNominationsPrivilege = user?.hasPrivilege(
    Privileges.DEED_INTERNAL_HANDLE_NONPROFIT_NOMINATIONS
  );

  useEffect(() => {
    if (
      user &&
      !(
        user.hasFeature(Features.USER_NOMINATE_NONPROFIT) ||
        hasGlobalHandleNonprofitNominationsPrivilege
      )
    ) {
      history.replace('/organizations');
    }
  }, [user]);

  return (
    <>
      <Helmet title="Nonprofit Nominations" />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1>Nonprofit Nominations</h1>
        {(user?.isAdmin || hasGlobalHandleNonprofitNominationsPrivilege) && (
          <FormControlLabel
            control={
              <Switch
                checked={viewAllCompanies}
                onChange={(): void => setViewAllCompanies(!viewAllCompanies)}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            }
            label="View all companies"
          />
        )}
      </div>
      {user && <NonprofitNominationsTable viewAllCompanies={viewAllCompanies} user={user} />}
    </>
  );
};

export default NonprofitNominationsPage;
